import styled from "@emotion/styled";
const Layout = styled.section``;

Layout.Container = styled.div`
  height: 100vh;
  color: #353535;
  overflow: hidden;
  background: #fff9ef;
`;

Layout.Content = styled.div`
  position: relative;
  max-width: 1024px;
  margin: 0 auto;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 100px);
`;

Layout.Header = styled.header`
  height: 100px;
`;

Layout.HeaderContent = styled.div`
  max-width: 1024px;
  margin: 0 auto;
  height: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0 30px;
`;

Layout.Title = styled.h1`
  font-size: 22px;
  font-weight: bold;
`;

Layout.HeroTitle = styled.h2`
  font-size: 72px;
  font-weight: bold;
  margin-top: 32px;
`;

Layout.HeroDescription = styled.p`
  font-size: 22px;
  margin-bottom: 160px;
`;

Layout.IconButton = styled.div`
  padding: 8px;
  border: 3px solid #2f5a61;
  border-radius: 50%;
`;
Layout.CTA = styled.button`
  background: #2f5a61;
  border-radius: 4px;
  padding: 6px 32px;
  font-weight: bold;
  text-transform: uppercase;
  color: #ffffff;
  width: 164px;
`;

export default Layout;
